import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RateioModeEnum } from 'Data/interfaces/Faturamento/IRateio';
import {
  Label,
  Option,
  OptionDescription,
  OptionText,
  OptionTitle,
  Options,
  Radio,
  Wrapper,
} from './styles';

interface ISplitModeSelector {
  value: RateioModeEnum;
  disabled?: boolean;
  onChange: (mode: RateioModeEnum) => void;
}

// "Uniforme / não uniforme" é vocabulário de especificação. Na interface os
// rótulos são "Divisão igual" e "Divisão personalizada", que descrevem o que
// cada modo faz em vez de negar um padrão.
const SplitModeSelector: FC<ISplitModeSelector> = ({ value, disabled, onChange }) => {
  const { t } = useTranslation('faturamento');

  const options = [
    {
      mode: RateioModeEnum.Uniform,
      title: t('rateio.splitEqualTitle'),
      description: t('rateio.splitEqualDescription'),
    },
    {
      mode: RateioModeEnum.Custom,
      title: t('rateio.splitCustomTitle'),
      description: t('rateio.splitCustomDescription'),
    },
  ];

  return (
    <Wrapper>
      <Label>{t('rateio.splitModeLabel')}</Label>
      <Options>
        {options.map((option) => {
          const selected = value === option.mode;
          return (
            <Option
              key={option.mode}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={option.title}
              disabled={disabled}
              $selected={selected}
              onClick={() => onChange(option.mode)}
            >
              <Radio $selected={selected} />
              <OptionText>
                <OptionTitle>{option.title}</OptionTitle>
                <OptionDescription>{option.description}</OptionDescription>
              </OptionText>
            </Option>
          );
        })}
      </Options>
    </Wrapper>
  );
};

export default SplitModeSelector;
